export default __webpack_public_path__ + "static/media/Group1327.bac43b84.svg";